<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">
          <!-- {{
            $router.currentRoute.name == "template-copy" ? "複製" : ""
          }} -->
          新增模版資料</span
        >
      </h4>

      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Template id -->
              <b-col cols="12">
                <b-form-group
                  label="模版編號："
                  label-for="id"
                  label-cols-md="3"
                  class="required"
                >
                  <div class="">
                    {{
                      newTemplateData.id
                        ? newTemplateData.template_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_template_name"
                >
                  <b-form-group
                    label="模版名稱："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.template_name"
                      placeholder="模版名稱"
                      :state="getValidationState(validationContext)"
                    />
                  </b-form-group>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="LOGO"
                  label-for="image"
                  label-cols-md="3"
                  class="required"
                >
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture-card"
                    ref="upload"
                    :action="uploadUrl"
                    :headers="headerObj"
                    name="logo"
                    :file-list="fileList"
                    multiple
                    :limit="1"
                    :data="newTemplateData"
                    :on-change="onChange"
                    :on-remove="toggleUpload"
                    :before-remove="beforeRemove"
                    :auto-upload="false"
                    :class="{ hideUpload: !showUpload }"
                  >
                    <img
                      class="w-100"
                      v-if="newTemplateData.logo_url && showUpload"
                      :src="newTemplateData.logo_url"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <label
                    v-if="newTemplateData.id == 0 && !newTemplateData.file"
                    class="error-text"
                  >
                    圖片是必填項</label
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_company_info"
                >
                  <b-form-group
                    label="公司資料"
                    label-for="company_info"
                    label-cols-md="3"
                    class="required"
                  >
                    <quill-editor v-model="newTemplateData.company_info" />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- bank_info -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_bank_info"
                >
                  <b-form-group
                    label="銀行帳號："
                    class="required"
                    label-for="bank_info"
                    label-cols-md="3"
                  >
                    <b-form-input
                      v-model="newTemplateData.bank_info"
                      :state="getValidationState(validationContext)"
                      placeholder="銀行帳號"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- address -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_address"
                >
                  <b-form-group
                    label="地址："
                    label-for="template_type"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.address"
                      :state="getValidationState(validationContext)"
                      placeholder="地址"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- website -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_website"
                >
                  <b-form-group
                    label="網址："
                    label-for="website"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.website"
                      :state="getValidationState(validationContext)"
                      placeholder="網址"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_phone"
                >
                  <b-form-group
                    label="電話："
                    label-for="phone"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.phone"
                      :state="getValidationState(validationContext)"
                      placeholder="電話"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_email"
                >
                  <b-form-group
                    label="電郵："
                    label-for="phone"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.email"
                      :state="getValidationState(validationContext)"
                      placeholder="電郵"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_fax"
                >
                  <b-form-group
                    label="傳真："
                    label-for="fax"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newTemplateData.fax"
                      :state="getValidationState(validationContext)"
                      placeholder="傳真"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { getDateTime } from "@/libs/helper";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  data() {
    return {
      required,
      email,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  methods: {
    hide() {
      this.$router.replace("/settings/receipt-format/list");
    },
    onSubmit() {
      if (this.newTemplateData.id == 0 && !this.newTemplateData.file) {
        return;
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          let formData = new FormData();
          formData.append("id", this.newTemplateData.id);
          formData.append("template_name", this.newTemplateData.template_name);

          if (this.newTemplateData.file) {
            if (this.newTemplateData.file.size >= 2097152) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error! Your Image size is larger then 2M",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              return;
            } else {
              formData.append("logo", this.newTemplateData.file);
            }
          }
          formData.append("company_info", this.newTemplateData.company_info);
          formData.append("bank_info", this.newTemplateData.bank_info);
          formData.append("address", this.newTemplateData.address);
          formData.append("website", this.newTemplateData.website);
          formData.append("phone", this.newTemplateData.phone);
          formData.append("email", this.newTemplateData.email);
          formData.append("fax", this.newTemplateData.fax);
          store
            .dispatch("template/editTemplate", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              // this.$emit("refetch-data");
              // if (this.newTemplateData.id == 0) {
              //   this.newTemplateData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newTemplateData = ref({
      id: 0,
      template_name: null,
      logo_image_path: null,
      stamp_image_path: null,
      company_info: null,
      bank_info: null,
      address: null,
      website: null,
      phone: null,
      email: null,
      fax: null,
    });

    watch(
      () => props.templateData,
      (newVal) => {
        newTemplateData.value = { ...newVal };
      }
    );

    const resetTemplateData = () => {
      newTemplateData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          template_name: null,
          logo_image_path: null,
          stamp_image_path: null,
          company_info: null,
          bank_info: null,
          address: null,
          website: null,
          phone: null,
          email: null,
          fax: null,
        })
      );
    };

    const showUpload = ref(true);
    const fileList = ref([]);
    const uploadUrl = process.env.VUE_APP_UPLOAD_URL;

    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };

    const onChange = (file) => {
      showUpload.value = !showUpload.value;
      newTemplateData.value.file = file.raw;
    };

    const beforeRemove = (file) => {
      newTemplateData.value.file = null;
    };

    const toggleUpload = () => {
      showUpload.value = !showUpload.value;
    };

    // watch(
    //   () => newTemplateData.value.project_id,
    //   (newVal, oldVal) => {
    //     if (router.currentRoute.query.quotation_id && isInitProject.value) {
    //       isInitProject.value = false;
    //       return;
    //     }

    //     if (router.currentRoute.name != 'template-create') {
    //       return;
    //     }

    //    if (!newVal) {
    //      newTemplateData.value.project_name = null;
    //      newTemplateData.value.address = null;
    //      return;
    //
    //    const data =
    //      props.projectOptions &&
    //      props.projectOptions.length > 0 &&
    //      props.projectOptions.filter((ele) => ele.id == newVal)[0]
    //    newTemplateData.value.project_name = data.project_name;
    //    newTemplateData.value.address = data.address;
    //      }
    // );

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetTemplateData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newTemplateData,

      showUpload,
      fileList,
      uploadUrl,
      headerObj,

      onChange,
      beforeRemove,

      toggleUpload,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
ol li {
  margin-bottom: 0.5rem;
}
.label-title {
  width: 186px;
}
</style>
